

import React, { useEffect, useState } from 'react';
import { find } from 'lodash';

import CustomerReviews from '../../shared/CustomerReviews';

const questionJson = [
  {
    id: 1,
    question: 'Why should I choose iCause? What makes it different from other crowdfunding sites?',
    text: 'The iCause fundraising model is unique. By choosing iCause to run your crowdfunding campaign you are giving your supporters the choice to donate in two ways – by contributing directly to your campaign OR by submitting a bill for review and using the savings to donate. iCause partners with a third-party marketing company to find you the best deal on your bill. If you choose to change suppliers through iCause, your chosen fundraiser will receive 30% of the saving.'
  },
  {
    id: 2,
    question: 'How do I donate directly to a friend or family members personal fundraising campaign?',
    text: 'Bootstrap is a sleek, intuitive, and powerful front-end framework for faster and easier web development. It is a collection of CSS and HTML conventions. <a href="https://www.tutorialrepublic.com/twitter-bootstrap-tutorial/" rel="noreferrer" target="_blank">Learn more.</a>'
  },
  {
    id: 3,
    question: 'How do I use my household bills to donate?',
    text: 'CSS stands for Cascading Style Sheet. CSS allows you to specify various style properties for a given HTML element such as colors, backgrounds, fonts etc. <a href="https://www.tutorialrepublic.com/css-tutorial/" rel="noreferrer" target="_blank">Learn more.</a>'
  },
  {
    id: 4,
    question: 'When will I receive the funds Ive raised?',
    text: 'In academic writing, readers expect each paragraph to have a sentence or two that captures its main point. They’re often called “topic sentences,” though many writing instructors prefer to call them “key sentences.” There are at least two downsides of the phrase “topic sentence.” First, it makes it seem like the paramount job of that sentence is simply to announce the topic of the paragraph. Second, it makes it seem like the topic sentence must always be a single grammatical sentence. Calling it a “key sentence” reminds us that it expresses the central idea of the paragraph. And sometimes a question or a two-sentence construction functions as the key.'
  },
  {
    id: 5,
    question: 'How do I use my credit card for donation?',
    text: 'A last thing to note about key sentences is that academic readers expect them to be at the beginning of the paragraph. (The first sentence this paragraph is a good example of this in action!) This placement helps readers comprehend your argument. To see how, try this: find an academic piece (such as a textbook or scholarly article) that strikes you as well written and go through part of it reading just the first sentence of each paragraph. You should be able to easily follow the sequence of logic. When you’re writing for professors, it is especially effective to put your key sentences first because they usually convey your own original thinking. It’s a very good sign when your paragraphs are typically composed of a telling key sentence followed by evidence and explanation.'
  }
];

const Faq = (props) => {
  const { getCustomerReviews, loading, customerReviews } = props;
  const [, setSearchKeyword] = useState('');
  const [selectedAnswer, setIdForQuestion] = useState(-1);

  useEffect(() => {
    getCustomerReviews()
  }, []); // eslint-disable-line react-hooks/exhaustive-deps 
  
  return (
    <div>
      <section className="banner banner-faq gen-banner faq-banner">
        <div className="container">
          <div className="row  ">
            <div className="col-lg-12 col-md-12 col-sm-12 m-auto">
              <div className="text-wrap">
                <h1 className="text-center">Do You Have any Query?</h1>
                <p className="text-center">Our FAQs contain advice for setting up accounts and campaigns, donating and our most common questions. Search the FAQs below.</p>
                {/* <Select onChange={(value) => setSelectedCompany(value)} placeholder='Company' style={{ width: 130 }}>
                  <Option value='school'>School</Option>
                  <Option value='charity'>Charity</Option>
                  <Option value='community'>Community</Option>
                  <Option value='organization'>Organization</Option>
                </Select> */}
                <div className="search-box">
                  <input
                    onChange={({ target }) => {
                      const value = target.value
                      // const ans = questionJson.find(({ text, id }) => {
                      //   if (text.includes(value) && value) {
                      //     return id;
                      //   }
                      // });
                      const ans = find(questionJson, ({ text }) => (text.includes(value) && value));
                      if (ans && ans.id >= 1) {
                        setIdForQuestion(ans.id);
                      } else {
                        setIdForQuestion(-1);
                      }
                      setSearchKeyword(target.value);
                    }}
                    type="search"
                    className="form-control  "
                    name=""
                    placeholder="Enter Charity Name. Ex Helpers, Founders, Gates"
                  />
                  <i
                    className="fa fa-search search-icon">
                  </i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="faq-help py-5 faq-sec-2">
        <div className="container">
          <h3 className="main-heading mt-4 mb-4 mt-md-0 text-center mb-3">FAQ'S & Help</h3>
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-6 col-12 text-right faq-img-card">
              <img src="/images/faq-sec-2-img-1.png" alt="img" className="img-fluid" />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-12 faq-img-card">
              <img src="/images/faq-sec-2-img-2.png" alt="img" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>
      <section className="accordion  accordion-two faq-sec-3">
        <div className="container">
          <h3 className="main-heading mt-md-0 text-center mb-5">Popular Question</h3>
          <div className="row">
            <div className="col-lg-10 mx-auto">

              <div className="accordion pt-2" id="accordionExample">
                {
                  questionJson.map(({ id, text, question }, index) => {
                    return (
                      <div key={index} className="card">
                        <div className="card-header" id={`heading${id}`}>
                          <h2 className="mb-0">
                            <button onClick={() => {
                              if (id === selectedAnswer) {
                                setIdForQuestion(-1);
                              } else {
                                setIdForQuestion(id);
                              }
                            }} type="button" className={`btn btn-link${selectedAnswer !== id ? ' collapsed' : ''}`}>
                              {question}
                              <i className="fa fa-plus"></i>
                            </button>
                          </h2>
                        </div>
                        {
                          selectedAnswer === id &&
                          <div>
                            <div className="card-body">
                              <p>{text}</p>
                            </div>
                          </div>
                        }
                      </div>
                    );
                  })
                }
                {/* <div className="card">
                  <div className="card-header" id="heading1">
                    <h2 className="mb-0">
                      <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse1"> Why should I choose iCause? What makes it different from other crowdfunding sites? <i className="fa fa-plus"></i></button>
                    </h2>
                  </div>
                  <div id="collapse1" className="collapse" aria-labelledby="heading1" data-parent="#accordionExample">
                    <div className="card-body">
                      <p>The iCause fundraising model is unique. By choosing iCause to run your crowdfunding campaign you are giving your supporters the choice to donate in two ways – by contributing directly to your campaign OR by submitting a bill for review and using the savings to donate. iCause partners with a third-party marketing company to find you the best deal on your bill. If you choose to change suppliers through iCause, your chosen fundraiser will receive 30% of the saving.</p>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header" id="heading2">
                    <h2 className="mb-0">
                      <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse2">How do I donate directly to a friend or family member's personal fundraising campaign?<i className="fa fa-plus"></i></button>
                    </h2>
                  </div>
                  <div id="collapse2" className="collapse  " aria-labelledby="heading2" data-parent="#accordionExample">
                    <div className="card-body">
                      <p>Bootstrap is a sleek, intuitive, and powerful front-end framework for faster and easier web development. It is a collection of CSS and HTML conventions. <a href="https://www.tutorialrepublic.com/twitter-bootstrap-tutorial/" rel="noreferrer" target="_blank">Learn more.</a></p>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header" id="heading3">
                    <h2 className="mb-0">
                      <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse3">How do I use my household bills to donate?<i className="fa fa-plus"></i></button>
                    </h2>
                  </div>
                  <div id="collapse3" className="collapse" aria-labelledby="heading3" data-parent="#accordionExample">
                    <div className="card-body">
                      <p>CSS stands for Cascading Style Sheet. CSS allows you to specify various style properties for a given HTML element such as colors, backgrounds, fonts etc. <a href="https://www.tutorialrepublic.com/css-tutorial/" rel="noreferrer" target="_blank">Learn more.</a></p>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header" id="heading4">
                    <h2 className="mb-0">
                      <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse4">When will I receive the funds I've raised?<i className="fa fa-plus"></i></button>
                    </h2>
                  </div>
                  <div id="collapse4" className="collapse" aria-labelledby="heading4" data-parent="#accordionExample">
                    <div className="card-body">
                      <p>CSS stands for Cascading Style Sheet. CSS allows you to specify various style properties for a given HTML element such as colors, backgrounds, fonts etc. <a href="https://www.tutorialrepublic.com/css-tutorial/" rel="noreferrer" target="_blank">Learn more.</a></p>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header" id="heading5">
                    <h2 className="mb-0">
                      <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse5">When will I receive the funds I've raised?<i className="fa fa-plus"></i></button>
                    </h2>
                  </div>
                  <div id="collapse5" className="collapse" aria-labelledby="heading5" data-parent="#accordionExample">
                    <div className="card-body">
                      <p>CSS stands for Cascading Style Sheet. CSS allows you to specify various style properties for a given HTML element such as colors, backgrounds, fonts etc. <a href="https://www.tutorialrepublic.com/css-tutorial/" rel="noreferrer" target="_blank">Learn more.</a></p>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <CustomerReviews
        data={customerReviews}
        loading={loading}
      />
    </div>
  );
};

export default Faq;
